<div *ngIf="posService.venueService.ooVenue" class="d-flex flex-column pos">
	<app-pos-idle *ngIf="!posService.loggedInEmployee.value.ID"></app-pos-idle>
	<app-pos-order-entry *ngIf="posService.loggedInEmployee.value.ID"></app-pos-order-entry>
</div>

<app-pos-print-printer-select
	*ngIf="commandAction?.command === 'print'"
	[checkKey]="commandAction.payload.checkKey"
	[seatKey]="commandAction.payload.checkKey"
	[checkNumber]="commandAction.payload.checkNumber"
	(closeDialogChange)="commandAction = undefined"
></app-pos-print-printer-select>
